// domain/capacitacion.detalle.js  (view model del detalle; funciones puras)
import { idsAsistentesActivos } from '../../shared/domain/asistentes';
import { nombrePorId, nombresPorIds } from '../../shared/domain/catalogo';
import { resolverProductores } from '../../shared/domain/productor';

/** Entidad + catálogos -> view model: nombres resueltos, asistentes vigentes con nombre/parcelas e imágenes. */
export const conDetalle = (capacitacion, { actividades = [], municipios = [], localidades = [], productores = [] } = {}) => ({
  ...capacitacion,
  actividad_nombre: nombresPorIds(actividades, capacitacion.id_actividades).join(', '),
  actividades_nombres: nombresPorIds(actividades, capacitacion.id_actividades),
  municipio_nombre: nombrePorId(municipios, capacitacion.id_municipio),
  localidad_nombre: nombrePorId(localidades, capacitacion.id_localidad),
  asistentes_detalle: resolverProductores(idsAsistentesActivos(capacitacion.asistentes), productores),
  imagenes: capacitacion.media || [],
});
